import React, { useState, useEffect } from "react";
import {
  Modal,
  Paper,
  Typography,
  TextField,
  IconButton,
  Button,
  Input,
  Grid,
  useTheme,
} from "@mui/material";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { toastAlert } from "../../../utils/AlertContext";
import { getAddIndicatorURL } from "../../../utils/ConstantsURL";

export const AddIndicator = ({
  token,
  open,
  close,
  selectedDate,
  idDocument,
  selectedIdSection,
  sections,
  refresh,
}) => {
  const [indicatorData, setIndicatorData] = useState({
    titulo: "",
    fecha: "",
    id_section: "",
    imagen: null,
  });

  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const validate = () => {
    return (
      !indicatorData.fecha ||
      !indicatorData.id_section ||
      !indicatorData.imagen
    );
  };

  const handleChange = (field) => (event) => {
    setIndicatorData({ ...indicatorData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    setIndicatorData({ ...indicatorData, imagen: event.target.files[0] });
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("titulo", indicatorData.titulo);
      formDataToSend.append("fecha", indicatorData.fecha);
      formDataToSend.append("id_documento", idDocument);
      formDataToSend.append("seccion_id", indicatorData.id_section);
      formDataToSend.append("image", indicatorData.imagen);

      const response = await fetch(getAddIndicatorURL(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok) {
        toastAlert("Indicador agregado correctamente", "success", 3000);
        setIndicatorData("");
        close();
        refresh();
      } else {
        toastAlert("Error al enviar la petición", "error");
        console.log("Error: " + result.message);
      }
      setLoading(false);
    } catch (error) {
      toastAlert("Error al enviar la petición: " + error, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setIndicatorData({
        titulo: "",
        fecha: selectedDate || "",
        id_section: selectedIdSection || "",
        imagen: null,
      });
    }
  }, [open, selectedDate, selectedIdSection]);

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          outline: "none",
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid item xs={10}>
            <Typography variant="h6">Agregar Nuevo Indicador</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton
              onClick={() => {
                close();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              label="Título"
              variant="outlined"
              fullWidth
              value={indicatorData.titulo}
              onChange={handleChange("titulo")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <TextField
              label="Fecha"
              variant="outlined"
              type="date"
              value={indicatorData.fecha}
              onChange={handleChange("fecha")}
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: selectedDate }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="select-autowidth-label">Sección</InputLabel>
              <Select
                labelId="select-autowidth-label"
                id="select-autowidth"
                value={indicatorData.id_section}
                onChange={handleChange("id_section")}
                autoWidth
                label="Seccion"
              >
                {sections.map((item) => (
                  <MenuItem key={item.ID_SECCION} value={item.ID_SECCION}>
                    {item.NOMBRE_SECCION}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Input
              accept="image/*"
              type="file"
              id="upload-file"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            <label htmlFor="upload-file">
              <Button
                variant="outlined"
                component="span"
                color="primary"
                fullWidth
                style={{
                  borderColor: "#8e8d89",
                  padding: "14px",
                  color: theme.palette.mode === 'dark' ? "#fff" : "black",
                }}
              >
                {indicatorData.imagen ? indicatorData.imagen.name : "Subir imagen"}
              </Button>
            </label>
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" style={{ marginTop: "20px" }}>
          <Grid item>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              loading={loading}
              disabled={validate()}
            >
              Agregar
            </LoadingButton>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};
